<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Acknowledgments"><div class="titlepage"><div><div><h1 class="title"><a id="d0e70" xmlns:saxon="http://icl.com/saxon">Acknowledgments </a></h1></div></div></div><p class="flush"><a id="d0e70" xmlns:saxon="http://icl.com/saxon">The most special thanks to Judith Weber, who pushed, encouraged and needled me to do this
        book for years, even though the subject wanted nothing to do with it. Her honest assessment,
        as well as cheerleading along the way, was my guiding light. </a></p><p><a id="d0e70" xmlns:saxon="http://icl.com/saxon">My entire life is one big collaboration. This book was no exception. Restauranting is a
        team sport. Writing <span class="emphasis"><em>Miss Ella</em></span> was too. Thank you to dear Jerry Shriver,
        who interviewed, researched, organized, edited and wrote much of <span class="emphasis"><em>Miss
            Ella.</em></span> Jerry got incredibly good at taking our long and winding interviews and
        notes and fashioning them into organized, coherent passages and chapters whilst channeling
        Mom in a scary spot-on way. And to Deb Shriver, who said, “When are you going to do the book
        on Ella? And you need to do a documentary, too.” And to Leslie Iwerks, who did the amazing
        documentary and allowed us to share in all her interviews. To Darla Fisackerly, who keeps me
        sane and typed the entire book from my handwritten notes and made good suggestions along the
        way. To Lally Brennan and Sam Fritz, who helped pull it all together. And to the amazing
        teams that never let the standards drop in our restaurants and allowed me the time to work
        on <span class="emphasis"><em>Miss Ella</em></span>: my cousin Brad Brennan, Steve Woodruff, Tory McPhail, Don
        Strunk, Chris Barbato, Tom Robey, Dan Davis, Arlene Nesser, Lelia Lambert, Juan Carlos
        Gonzalez and Meg Bickford. And Reginelli’s leaders, Darryl Reginelli and Lisa Millet. </a></p><p><a id="d0e70" xmlns:saxon="http://icl.com/saxon">Thanks to our wonderful good friend Cokie Roberts, who feels like family, for a charming,
        warm foreword. And to the amazing list of dear friends who agreed to be interviewed for the
        book and helped us find old photographs and articles: Daniel Boulud, Gene Bourg, Alex
        Brennan Martin, Dickie Brennan, Dottie Brennan, Lally Brennan, Ralph Brennan, Frank
        Brigtsen, Leah Chase, Tom Fitzmorris, Joe Henican, Emeril Lagasse, Kate Lindquist, Maggie
        McCabe, Danny Meyer, Drew Nieporent, Emily Oppenheimer, Chris Owens, John Pope, Julia Reed,
        Melvin Rodrigue, Jack Robinson, Jerry Siegel, Ron Thompson, Poppy Tooker, Jeremiah Tower,
        Hal Williamson, Donn Young, and Tim and Nina Zagat. </a></p><p><a id="d0e70" xmlns:saxon="http://icl.com/saxon">And to Gibbs Smith and delightful editors Madge Baird and Kerry McShane and designer Renee
        Bond. </a></p><p class="attribution"><a id="d0e70" xmlns:saxon="http://icl.com/saxon">—Ti Adelaide Martin</a></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?7a26b66e